import { makeAutoObservable } from "mobx"
import { DragDropFile } from "react-sdk/activities/DragDrop"
import { QCMFile } from "react-sdk/activities/QCM"
import { ReordonnerFile } from "react-sdk/activities/Reordonner"
import DataManager, { DataUtils } from "react-sdk/haxelibs/DataManager"
import Analytics from "react-sdk/Vertx/Analytics"
import SaveGame from "../SaveGame"
import Minigame from "./Minigame"
import AppState from "../AppState"
import { SwipeFile } from "react-sdk/activities/Swipe"
import { QRLFile } from "react-sdk/activities/QRL"


class Minigames {
  /** @type {QCMFile} */
  qcms = null

  /** @type {DragDropFile} */
  dragdrops = null


  /** @type {ReordonnerFile} */
  reordonners = null

  /** @type {SwipeFile} */
  swipes = null

  /** @type {QRLFile} */
  qrls = null

  /** @type {Array<Minigame>} */
  all = []


  currentLevelIndex = null
  /** @type {Minigame} */
  current = null

  /**
   * Pour contenir un MG qui représente un groupe de MG
   * @type {Minigame}
   */
  currentGroup = null

  onEnd = null

  history = []
  constructor() {
    makeAutoObservable(this)
  }

  /**
   *
   * @param {String} minigamesFilename
   */
  init(minigamesFilename, files) {

    let {
      qcms,
      dragdrops,
      reordonner,
      swipes,
      qrls
    } = files

    this.qcms = new QCMFile(qcms)
    this.qcms.observeAll()

    this.dragdrops = new DragDropFile(dragdrops)
    this.dragdrops.observeAll()

    this.reordonners = new ReordonnerFile(reordonner)
    this.reordonners.observeAll()

    this.swipes = new SwipeFile(swipes)
    this.swipes.observeAll()

    this.qrls = new QRLFile(qrls)
    this.qrls.observeAll()


    let minigames = DataManager.getFile(minigamesFilename);

    this.all = minigames.lines.filter(line => line.id).map(line => new Minigame(line))

    this.all.forEach(mg => {
      let c = DataUtils.getChildren(mg.line, "parent");
      if (c && c.length > 0) {
        mg.children = c.map(childLine => this.get(childLine.id))
      }
    })
  }

  get ids() {
    return this.all.map(c => c.id)
  }

  get(id) {
    return this.all.find(c => c.id === id)
  }

  get unlocked() {
    return this.all.filter(mg => mg.unlocked)
  }

  getAllInChapter(c) {
    return this.all.filter(mg => mg.chapter == c)
  }

  /**
   *
   * @param {string} id l'id de la ligne principale du mg dans le .data
   * @param {Function} onFinished callback appelée à la fin du mg
   */
  play(id, onFinished) {
    this.onEnd = onFinished

    let mg = this.get(id)

    if(!mg) {
      throw new Error(`Minigame ${id} does not exist`)
    }

    this.launch(mg)
  }

  /**
   *
   * @param {Minigame} minigame le minigame à lancer
   * @param {Function} onfinished callback appelée à la fin du mg
   */
  launch(minigame) {

    console.log("launch minigame ", minigame)

    if (minigame.isContainer()) {
      this.currentGroup = minigame
      this.launchNextInGroup()
    } else {
      this.reallyLaunch(minigame)
    }
  }

  launchNextInGroup() {
    let currIndex = -1;
    if (this.current)
      currIndex = this.currentGroup.findCurrentMinigameIndex(this.current)

    ++currIndex;
    if (currIndex >= this.currentGroup.children.length) {
      this.history.push(this.currentGroup)
      this.currentGroup = null;
      this.current = null;
      if (this.onEnd) {
        let tmp = this.onEnd
        this.onEnd = null
        tmp()
      }
    } else {
      this.launch(this.currentGroup.children[currIndex])
    }

  }

  reallyLaunch(minigame) {
    this.current = minigame
    Analytics.changeScreenEvents(null, "popup.MINIGAME." + this.current.id)
  }

  stop() {

    console.log("minigame stop : ", this.current, "\n", this.currentGroup)

    if (this.current) {
      if (this.current.elementRef?.result?.normalized_score)
        this.current.setScore(this.current.elementRef.result.normalized_score)
      else
        this.current.setScore(0)
      Analytics.changeScreenEvents("popup.MINIGAME." + this.current.id)

      if (AppState.astekActivity) {
        if (!AppState.astekActivity.userResults.mgResults[this.current.id])  {
          this.current.chapter.refreshStars()
          SaveGame.updateState()
          AppState.astekActivity.saveMinigameResult(this.current.id, this.current.stateToJson()).then(() => this.#continueAfterStop())
          return
        }
      } else {
        
        this.current.chapter.refreshStars()
        SaveGame.updateState()
      }
    }

    this.#continueAfterStop()


  }

  #continueAfterStop() {
    if (this.currentGroup) {
      this.launchNextInGroup();
    } else {
      this.history.push(this.current)
      this.current = null;
      if (this.onEnd) {
        let tmp = this.onEnd
        this.onEnd = null
        tmp()
      }
    }
  }

  reset() {
    this.all.forEach((mg) => mg.reset())
  }

  stateToJson() {
    // on garde que les mgs qui ont un résultat
    let mgsToSave = this.all.filter(mg => mg.elementRef?.result);
    return mgsToSave.map(mg => {
      return {
        id : mg.id,
        state : mg.stateToJson()
      }
    })
  }
  stateFromJson(data) {
    if (!data)
      return
    
    data.forEach(d => {
      let mg = this.get(d.id)
      if (mg)
        mg.stateFromJson(d.state)
    })
  }
}

export default new Minigames()
